import React from 'react';
import { HeroOferta } from '../components/HeroOferta';
import { ProblemaSection } from '../components/ProblemaSection';
import { SemanasSection } from '../components/SemanasSection';
import { IncluyeSection } from '../components/IncluyeSection';
import { ParaQuienSection } from '../components/ParaQuienSection';
import { TestimoniosSection } from '../components/TestimoniosSection';
import { PrecioSection } from '../components/PrecioSection';
import { ObjecionesSection } from '../components/ObjecionesSection';
import { FaqSection } from '../components/FaqSection';
import { CierreSection } from '../components/CierreSection';
import { FooterOferta } from '../components/FooterOferta';
import { WhatsAppFloat } from '../components/WhatsAppFloat';
type OfertaProps = {
  mostrarTestimonios?: boolean;
};
export function Oferta({
  mostrarTestimonios = true
}: OfertaProps) {
  return <div className="min-h-full w-full bg-violet font-sans" data-id="element-133" data-mp="2wgc1iz88poxt">
      <HeroOferta data-id="element-134" data-mp="2wfsmbq9z5enh" />
      <main data-id="element-135" data-mp="2wieo19a6ozxs">
        <ProblemaSection data-id="element-136" data-mp="1zvlc0gh5xlud" />
        <SemanasSection data-id="element-137" data-mp="1zutqxzl6z6ic" />
        <IncluyeSection data-id="element-138" data-mp="1zua5wa08w203" />
        <ParaQuienSection data-id="element-139" data-mp="1zxo9tmok4j9n" />
        {mostrarTestimonios && <TestimoniosSection data-id="element-140" data-mp="1vurmjio2nyzd" />}
        <PrecioSection data-id="element-141" data-mp="1vtgn1v1ntde2" />
        <ObjecionesSection data-id="element-142" data-mp="1vwcgp76h5fwp" />
        <FaqSection data-id="element-143" data-mp="29uati855d4a3" />
        <CierreSection data-id="element-144" data-mp="29sq0imyhdtec" />
      </main>
      <FooterOferta data-id="element-145" data-mp="29romc9m64qse" />
      <WhatsAppFloat data-id="element-146" data-mp="24uoepu9o7fz6" />
    </div>;
}